export default "__VITE_ASSET__BdLrggKb__"